<template>
            <main class="main">
              <organization_header :users="true"/>
                <div class="worker">
                    <div class="worker-header">
                        <div class="worker-search">
                            <input name="search" v-model="search" placeholder="Поиск">
                            <img class="hover_btn" src="@/assets/img/worker/search.svg" alt="">
                        </div>
                      <router-link :to="{name: 'wadd'}" style="width: 200px"><app-button>Добавить сотрудника</app-button></router-link>
                    </div>
                    <div class="worker-main">
                        <table class="worker-table">
                            <tr>
                                <!--<th>ID<img src="@/assets/img/main/open.svg"></th>-->
                                <th>Фамилия Имя</th>
                                <th width="27%">Роль</th>
                                <th>Телефон</th>
                                <th>E-mail</th>
                                <th style="width: 80px;"></th>
                            </tr>
                            <worker_block @changeRole="changeRole($event)" @change="$refs.changeUser.open($event)"  @invite="inviteRemove($event)" v-for="worker in workers" :key="worker.id" :worker="worker"/>
                        </table>
                    </div>
                </div>
                <change-user-modal ref="changeUser" @saved="change($event)"/>
            </main>
</template>

<script>
import 'vue-select/dist/vue-select.css';

import ChangeUserModal from "@/components/modals/change-user-modal"
import worker_block from "@/components/WorkerTable.vue"
import AppButton from "@/components/app-button";
import organization_header from "@/components/OrganizationHeader.vue"


export default {
    name: "edit",
    data: function () {
        return {
            workers: [],
            search: ''
        }
    },
    components: {
      AppButton,
        worker_block,
      ChangeUserModal,
      organization_header
    },
    mounted () {
        this.getUsers()
    },
    methods: {
        changeRole(data){
          console.log(data)
          this.$http.post('/change-user-role', {
            token: localStorage.getItem('token'),
            id: data.id,
            position: data.role,
          }).then((res) => {
            if (res.data.success){
              this.getUsers();
            }
          }).catch((error) => {
            console.log(error)
          })
        },
        change(data){
          this.$http.post('/change-user-active', {
            token: localStorage.getItem('token'),
            data
          }).then((res) => {
              if (res.data.success){
                this.getUsers();
              }
          }).catch((error) => {
            console.log(error)
          })
        },
        inviteRemove(id){
          this.$http.post('/invite-user-remove', {
            token: localStorage.getItem('token'),
            id: id
          }).then((res) => {
              if (res.data.success){
                this.getUsers();
              }
          }).catch((error) => {
            console.log(error)
          })
        },
        getUsers(val = '') {
          this.workers = [];
            if (localStorage.getItem('token')) {
                this.$http.post('/get-users', {
                    token: localStorage.getItem('token'),
                    search: val
                }).then(({data}) => {
                    if (data.users) {
                        this.workers = data.users
                    }
                })
                .catch((error) => {
                        console.log(error)
                })
            }
        }
    },
    watch: {
        search: function(val) {
            this.getUsers(val);
        }
    }
}
</script>

<style scoped lang="scss">
    .worker {
        &-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
        }

        &-search {
            position: relative;
            width: 320px;

            > input {
                border: 1px solid #EEF0F3;
                box-sizing: border-box;
                border-radius: 4px;
                width: 100%;
                height: 40px;
                padding: 0 40px 0 15px;
                outline: none;
            }

            > img {
                position: absolute;
                right: 15px;
                bottom: 50%;
                transform: translateY(50%);
                width: 14px;
                height: 14px;
            }
        }

        &-add {
            background: #2CB181;
            font-weight: 500;
            font-size: 14px;
            color: #FFFFFF;
            height: 40px;
            border: none;
            outline: none;
            border-radius: 4px;
            width: 240px;
        }
    }
    th{
        img{
            margin-right: -11px;
            margin-left: 2px;
        }
    }
</style>
